import { SelfCreatedUpdatedBy, HREFTemplated } from '../../../../app/shared/model/link.model';
import { LogBookUser } from 'ng/src/app/users/shared/user.model';

enum SystemParameterNames {
	TUTORIAL_VIDEOS = 'configData.tutorialVideos'
}

export class SystemParameter {
	static readonly parameterNames = SystemParameterNames
}

export interface SystemParameter {
	created: string;
	updated: string;
	name: string;
	value: string;
	_embedded: {
		updatedBy: LogBookUser;
		createdBy: LogBookUser;
	};
	_links: SelfCreatedUpdatedBy & {
		systemParameter: HREFTemplated;
	};
}

export class NewParameterDialog {
	name = '';
	value = '';
	submitted = false;

	constructor(public visible = false) { }
}

export class SystemParameterViewModel {
	link: string;
	name: string;
	value: string;

	constructor(parameter: SystemParameter) {
		this.link = parameter._links.self.href;
		this.name = parameter.name;
		this.value = parameter.value;
	}
}